import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ProtectedRoute from "./routes/ProtectedRoute";
import DashboardHome from "./pages/dashboard/DashboardHome";
import AddProperty from "./pages/dashboard/AddProperty";
import PropertyList from "./pages/dashboard/PropertyList";
import TimeSlots from "./pages/dashboard/TimeSlots";
import BookViewing from "./pages/Public/BookViewing";
import { Navigate } from "react-router-dom";
import Profile from "./pages/dashboard/Profile";
import CancelBooking from "./pages/Public/CancelBooking";
import RequireAuth from "./components/RequireAuth"
import RequireAdmin from "./pages/admin/RequireAdmin"
import AdminDashboard from "./pages/admin/AdminDashboard"
import LandingPage from "./components/LandingPage";


function App() {
    return (

        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login/>}/>
                <Route path="/register" element={<Register/>}/>

                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <DashboardHome/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/dashboard/add"
                    element={
                        <ProtectedRoute>
                            <AddProperty/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/dashboard/properties"
                    element={
                        <ProtectedRoute>
                            <PropertyList/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/dashboard/properties/:propertyId/timeslots"
                    element={
                        <ProtectedRoute>
                            <TimeSlots/>
                        </ProtectedRoute>
                    }
                />
                <Route path="/property/:propertyId/boek" element={<BookViewing/>}/>
                <Route path="/property/:propertyId/boek" element={<BookViewing />} />
                <Route path="/" element={<LandingPage />} />
                <Route path="/dashboard" element={<Navigate to="/dashboard" replace />} />
                <Route
                    path="/dashboard/profile"
                    element={
                        <ProtectedRoute>
                            <Profile />
                        </ProtectedRoute>
                    }
                />
                <Route path="/cancel-booking" element={<CancelBooking />} />
                <Route
                    path="/admin"
                    element={
                        <RequireAuth>
                            <RequireAdmin>
                                <AdminDashboard />
                            </RequireAdmin>
                        </RequireAuth>
                    }
                />

            </Routes>
        </BrowserRouter>
    );
}

export default App;
